export enum SuppressionSources {
  ADMIN = "admin_mailing",
}

export const SuppressionSourcesOptions = [
  { name: "Admin", value: SuppressionSources.ADMIN },
]
